// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecentlyViewed_wrapper__1uRyk","package":"RecentlyViewed_package__14ZD4"};